<template>
    <!--    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">-->
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-cell-group>
            <h2 style="padding: 0.3rem 0;text-align: center">2020-2021年全国啦啦操联赛</h2>
            <van-field v-model="row.current_index + 1" label="序号" placeholder="请输入身份证号" readOnly/>
            <van-field v-model="row.subject.subject_name" label="参赛项目" placeholder="请输入参赛项目" readOnly/>
            <van-field v-model="row.subject.danwei" label="参赛单位" placeholder="请输入姓名" readOnly/>
            <van-field v-model="row.subject.mingcheng" label="参赛队伍" placeholder="请输入姓名" readOnly/>

        </van-cell-group>
        <div class="score-box">
            <div class="score-title">比赛用时</div>
            <div class="score-content">
                <div class="score-time" v-if="type == 'auto'">
                    <h3 class="time-value" v-if="timeString">{{timeString}}</h3>
                    <h3 class="time-value" v-else>00:00:00</h3>
                    <div class="time-button flex-between">
                        <van-button type="info" size="large" @click="onTimeContinue"
                                    :disabled="getTimeSecond(formData.time) > 0? true: false" v-if="status == 'pause'">
                            继续计时
                        </van-button>
                        <van-button type="info" size="large" @click="onTimeStart"
                                    :disabled="getTimeSecond(formData.time) > 0? true: false" v-else>开始计时
                        </van-button>
                        <van-button type="info" size="large" @click="onTimePause"
                                    :disabled="getTimeSecond(formData.time) > 0 || !status ?true: false">暂停
                        </van-button>
                        <van-button type="info" size="large" @click="onTimeRestart"
                                    :disabled="getTimeSecond(formData.time) > 0? true: false">重新计时
                        </van-button>
                    </div>
                </div>

                <div class="score-time" v-else style="margin-top: 0.3rem">
                    <div class="time-button flex-between">
                        <div>请输入比赛用时：</div>
                        <van-field v-model="time.minute" :disabled="getTimeSecond(formData.time) > 0 ?true: false"/>
                        <div>分</div>
                        <van-field v-model="time.second" :disabled="getTimeSecond(formData.time) > 0 ?true: false"/>
                        <div>秒</div>
                    </div>
                </div>

                <div style="margin-top: 0.3rem">
                    <van-button type="primary" round size="large" @click="onSubmit" disabled="disabled"
                                v-if="getTimeSecond(formData.time) > 0">已提交
                    </van-button>
                    <van-button type="info" round size="large" @click="onSubmit" v-else>提交</van-button>
                </div>
            </div>

            <div class="score-foot">
                <van-button @click="onTypeChange" v-if="type == 'auto'">手动计时</van-button>
                <van-button @click="onTypeChange" v-else>自动计时</van-button>
            </div>
        </div>
    </div>
    <!--    </van-pull-refresh>-->

</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .time-button .van-cell {
        width: 80px;
    }

    .score-box {
        padding: 1rem 0.3rem 0.3rem;
    }

    .score-title, .time-value {
        text-align: center;
    }

    .time-value {
        font-size: 30px;
        padding: 0.2rem 0;
    }

    .time-button button {
        margin-right: 0.2rem;
    }

    .time-button button:last-child {
        margin-right: 0;
    }

    .score-foot {
        position: fixed;
        bottom: 0.4rem;
        right: 0.3rem;
    }


    .bottom-button {
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
    }


    .van-tag {
        margin-right: 10px;
        text-align: center;
    }

    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import validator from "../../../utils/validator";

    import {
        Cell,
        Field,
        Tag,
        Stepper,
        Switch,
        Form,
        Toast,
        Button
    } from 'vant';

    Vue.use(Cell).use(Tag).use(Stepper).use(Field).use(Switch).use(Form).use(Toast).use(Button);

    export default {
        name: 'TimeScore',
        components: {},
        data: function () {
            return {
                validator,
                isLoading: false,
                saveLoading: false,
                row: {
                    subject: {subject_name: '', jgroup: 0, stime: ''}
                },
                id: 0,
                status: '', // pause
                timeTotal: 0,
                timeString: 0,
                time: {
                    hour: 0,
                    minute: '',
                    second: '',
                },
                formData: {
                    id: 0,
                    time: ''
                },
                type: 'auto', // auto manual

                timer: ''
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.fetch()
            that.init()
        },
        watch: {},
        destroyed() {
        },
        methods: {
            fetch() {
                let that = this;
                that.$api.post('/api/dscore/subjectDetail', {
                    num: localStorage.getItem('_id_num')
                }, (res) => {
                    let row = that.row = res.data.row;

                    that.timeString = that.formData.time = row.subject.stime
                    that.id = that.formData.id = row.subject.id
                    that.isLoading = false;

                    that.id = res.data.row.id
                    that.onStatusChange(1)
                }, (res) => {
                    Toast(res.msg)
                })
            },

            onRefresh() {
                let that = this
                that.fetch()

                // setTimeout(() => {
                //     Toast('刷新成功');
                //     that.fetch()
                // }, 1000);
            },

            onTimeStart() {
                console.log('onTimeStart')
                let that = this,
                    timeTotal = that.timeTotal

                that.status = 'start'

                that.timer = setInterval(function () {
                    timeTotal += 1

                    let today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
                    let endTime = timeTotal * 1000 + today

                    let date = that.formatDate(endTime, 'h:m:s')

                    that.timeString = date
                    that.timeTotal = timeTotal
                    console.log("timeTotal", timeTotal, date)
                }, 1000)
            },
            onTimePause() {
                console.log('onTimePause', this.timeTotal)
                this.status = 'pause'
                clearInterval(this.timer)
            },
            onTimeRestart() {
                clearInterval(this.timer)
                this.timeTotal = 0
                this.onTimeStart()
            },

            // 继续计时
            onTimeContinue() {
                clearInterval(this.timer)
                this.onTimeStart()
            },

            // 格式化为时间字符串
            // minute 添加的时间
            formatTimeToTime(time, minute) {
                // let time = '03:58:00',
                //     minute = 3,
                let date = '',
                    today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()

                // 如何得到 03:33:00

                var hour = time.split(':')[0]
                var min = time.split(':')[1]
                var sec = time.split(':')[2]
                var s = Number(hour * 3600) + Number(min * 60) + Number(minute * 60) + Number(sec)

                let endTime = s * 1000 + today

                date = this.formatDate(endTime, 'h:m:s')
                // console.log('formatTimeToTime', min,endTime, date)

                return date
            },

            formatDate(num, format) {
                const formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
                const returnArr = [];
                const date = new Date(num);
                returnArr.push(date.getFullYear()); // 取得4位数的年份
                returnArr.push(this.formatNumber(date.getMonth() + 1)); // 取得日期中的月份，其中0表示1月，11表示12月
                returnArr.push(this.formatNumber(date.getDate())); // 返回日期月份中的天数（1到31）
                returnArr.push(this.formatNumber(date.getHours())); // 返回日期中的小时数（0到23）
                returnArr.push(this.formatNumber(date.getMinutes())); // 返回日期中的分钟数（0到59）
                returnArr.push(this.formatNumber(date.getSeconds())); // 返回日期中的秒数（0到59）

                for (const i in returnArr) {
                    // 判断对象是否含有某个非继承属性
                    if ({}.hasOwnProperty.call(returnArr, i)) {
                        format = format.replace(formateArr[i], returnArr[i]); // 替换
                    }
                }
                return format;
            },
            formatNumber(n) {
                n = n.toString();
                return n[1] ? n : `0${n}`;
            },

            // 获取秒数
            getTimeSecond(time) {
                var hour = time.split(':')[0]
                var min = time.split(':')[1]
                var sec = time.split(':')[2]
                var s = Number(hour * 3600) + Number(min * 60) + Number(sec)

                // console.log(hour, min, sec, Number(min * 60), Number(sec * 60))

                // console.log(time + '-----' + s, this.time)
                return s
            },

            onTypeChange() {
                let that = this,
                    string = that.timeString
                this.type = this.type == 'auto' ? 'manual' : 'auto'

                if (that.type == 'auto') {
                    let time = that.time,
                        date = time.hour + ':' + time.minute + ':' + time.second

                    that.timeString = that.formatTimeToTime(date,0)
                    that.timeTotal = that.getTimeSecond(date)
                } else {
                    that.time.hour = string.split(':')[0]
                    that.time.minute = string.split(':')[1]
                    that.time.second = string.split(':')[2]
                }
            },
            onSubmit() {
                let that = this
                if (that.type == 'manual') {
                    let time = that.time,
                        date = time.hour + ':' + time.minute + ':' + time.second

                    console.log(date)

                    that.timeString = that.formatTimeToTime(date,0)
                    that.timeTotal = that.getTimeSecond(date)
                }

                console.log(that.timeString)


                that.formData.time = that.timeString
                if (!that.formData.time) {
                    Toast('请先计时')
                    return
                }

                that.saveLoading = true

                that.$api.post('/api/dscore/timeSave', that.formData, (res) => {
                    // 通知服务端
                    let data = JSON.stringify({
                        'type': 'caipan_common',
                        'token': localStorage.getItem('_id_num'),
                        'start_id': that.id,
                    })

                    that.socket.send(data)
                    that.saveLoading = false


                    Toast.success('提交成功')
                }, (res) => {
                    if (res.code == 401 || res.code == 402) {
                        if (window.isApp()) {
                            rbLink({
                                name: 'login', 'query': {}
                            }, 'replace');
                            return false;
                        }
                        that.loginShow = true
                    } else {
                        Toast(res.msg)
                    }

                    that.saveLoading = false
                })

            },

            onStatusChange(status) {
                let that = this

                that.$api.post('/api/dscore/caipanStatusChange', {
                    id: that.id,
                    status: status
                }, (res) => {
                    // 通知服务端
                    let data = JSON.stringify({
                        'type': 'caipan_common',
                        'token': localStorage.getItem('_id_num'),
                        'start_id': that.id,
                    })

                    console.log('onStatusChange')

                    that.socket.send(data)
                }, (res) => {
                    Toast(res.msg)
                })
            },

            init: function () {
                if (typeof (WebSocket) === "undefined") {
                    alert("您的浏览器不支持socket")
                } else {
                    // 实例化socket
                    let that = this
                    // this.socket = new WebSocket(`ws://sjzh2019.ticp.io:8888/dev/websocket/${this.userId}`);
                    this.socket = new WebSocket(wsRoot);
                    // 监听socket连接
                    this.socket.onopen = this.open
                    // 监听socket错误信息
                    this.socket.onerror = this.error
                    // 监听socket消息
                    this.socket.onmessage = this.getMessage

                    this.socket.onclose = function (e) {
                        that.init()
                        console.log('websocket 断开：' + e.code + ' ' + e.reason + ' ' + e.wasClean)
                        console.log(e)
                    }

                    // console.log(this.socket)
                }
            },
            open: function () {
                console.log("socket连接成功")
                this.heartStart();
                this.heartCheck();
            },
            error: function () {
                console.log("连接错误")
                this.reconnect()
            },
            getMessage: function (msg) {
                if (!msg.data) return
                // console.log('getMessage', msg.data)
                let data = JSON.parse(msg.data)
                let that = this

                switch (data.type) {
                    case 'heart_check_success':
                        // 心跳检测
                        console.log('heart_check_success')
                        break;
                    case 'heart_check':
                        // 心跳检测
                        console.log('heart_check')
                        let val = JSON.stringify({
                            'type': 'heart_check',
                        })
                        that.socket.send(val);
                        break;
                    case 'sai_start':
                        // 开始比赛
                        // 实时刷新 页面
                        this.onRefresh()
                        break;
                    case 'socket_close':
                        // 开始比赛
                        // 实时刷新 页面
                        this.clearAll()
                        this.reconnect()
                        break;
                }
                console.log(data)
            },
            send: function (params) {
                this.socket.send(params)
            },
            close: function () {
                console.log("socket已经关闭")
                this.reconnect()
            },

            heartStart() {
                let that = this;

                let val = JSON.stringify({
                    'type': 'heart_start',
                    'token': localStorage.getItem('_id_num'),
                    'id': that.formData.id,
                })
                that.socket.send(val);
            },

            heartCheck() {
                let that = this;
                that.heartTimer = setInterval(function () {
                    let val = JSON.stringify({
                        'type': 'heart_check',
                        'token': localStorage.getItem('_id_num'),
                        'id': that.formData.id,
                    })
                    that.socket.send(val);
                }, 8000);
            },

            reconnect() {
                let that = this,
                    lockReconnect = that.lockReconnect,
                    tt = that.timer

                console.log('reconnect')
                // 重连
                if (lockReconnect) return
                lockReconnect = true;
                //没连接上会一直重连，设置延迟避免请求过多
                tt && clearTimeout(tt);
                that.timer = setTimeout(function () {
                    that.init();
                    lockReconnect = false;
                }, 4000);

            },

        }
    }
</script>



// WEBPACK FOOTER //
// TimeScore.vue?4c1f977c